var _rect, _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPanelProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 31,
    height: 30,
    fill: "var(--background)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-614 -910C-614 -911.105 -613.105 -912 -612 -912H4551C4552.1 -912 4553 -911.105 4553 -910V1199C4553 1200.1 4552.1 1201 4551 1201H-612C-613.105 1201 -614 1200.1 -614 1199V-910Z",
    fill: "var(--background)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-612 -911H4551V-913H-612V-911ZM4552 -910V1199H4554V-910H4552ZM4551 1200H-612V1202H4551V1200ZM-613 1199V-910H-615V1199H-613ZM-612 1200C-612.552 1200 -613 1199.55 -613 1199H-615C-615 1200.66 -613.657 1202 -612 1202V1200ZM4552 1199C4552 1199.55 4551.55 1200 4551 1200V1202C4552.66 1202 4554 1200.66 4554 1199H4552ZM4551 -911C4551.55 -911 4552 -910.552 4552 -910H4554C4554 -911.657 4552.66 -913 4551 -913V-911ZM-612 -913C-613.657 -913 -615 -911.657 -615 -910H-613C-613 -910.552 -612.552 -911 -612 -911V-913Z",
    fill: "currentColor",
    fillOpacity: 0.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_1)",
    filter: "url(#filter0_d_0_1)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 393,
    height: 852,
    transform: "translate(-25 -790)",
    fill: "var(--background)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_0_1)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 393,
    height: 77,
    transform: "translate(-25 -15)",
    fill: "var(--background)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 0.5,
    width: 29,
    height: 29,
    rx: 14.5,
    stroke: "currentColor"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-4-outside-1_0_1",
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 8.5,
    width: 13,
    height: 13,
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "var(--background)",
    x: 9,
    y: 8.5,
    width: 13,
    height: 13
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4998 9.5C16.2188 9.49979 16.9189 9.71767 17.4974 10.1216C18.0759 10.5256 18.5024 11.0944 18.7141 11.7446C18.9258 12.3947 18.9117 13.092 18.6739 13.734C18.436 14.376 17.9869 14.929 17.3925 15.3117C18.4242 15.6698 19.3191 16.3118 19.9619 17.1552C20.6047 17.9986 20.9661 19.0047 20.9994 20.044C21.0025 20.1017 20.9934 20.1594 20.9727 20.2137C20.9519 20.268 20.9199 20.3179 20.8785 20.3604C20.8371 20.4028 20.7871 20.437 20.7316 20.461C20.676 20.4849 20.616 20.4981 20.5549 20.4998C20.4939 20.5015 20.4332 20.4917 20.3762 20.4708C20.3193 20.45 20.2673 20.4186 20.2233 20.3785C20.1794 20.3385 20.1443 20.2905 20.1202 20.2374C20.0961 20.1843 20.0835 20.1272 20.083 20.0695C20.0466 18.9423 19.5478 17.8729 18.6923 17.0878C17.8368 16.3027 16.6919 15.8636 15.5001 15.8636C14.3083 15.8636 13.1634 16.3027 12.3079 17.0878C11.4524 17.8729 10.9536 18.9423 10.9172 20.0695C10.9136 20.1845 10.8618 20.2935 10.7732 20.3724C10.6846 20.4513 10.5666 20.4937 10.445 20.4903C10.3234 20.4868 10.2082 20.4378 10.1248 20.354C10.0414 20.2702 9.99656 20.1585 10.0002 20.0434C10.0337 19.0042 10.3951 17.9982 11.0379 17.1549C11.6807 16.3117 12.5755 15.6697 13.6071 15.3117C13.0127 14.929 12.5636 14.376 12.3257 13.734C12.0879 13.092 12.0738 12.3947 12.2855 11.7446C12.4973 11.0944 12.9237 10.5256 13.5022 10.1216C14.0807 9.71767 14.7808 9.49979 15.4998 9.5ZM13.0545 12.6815C13.0545 13.2951 13.3121 13.8837 13.7707 14.3176C14.2293 14.7515 14.8513 14.9953 15.4998 14.9953C16.1484 14.9953 16.7703 14.7515 17.2289 14.3176C17.6875 13.8837 17.9452 13.2951 17.9452 12.6815C17.9452 12.0678 17.6875 11.4793 17.2289 11.0454C16.7703 10.6115 16.1484 10.3677 15.4998 10.3677C14.8513 10.3677 14.2293 10.6115 13.7707 11.0454C13.3121 11.4793 13.0545 12.0678 13.0545 12.6815Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M15.4998 9.5C16.2188 9.49979 16.9189 9.71767 17.4974 10.1216C18.0759 10.5256 18.5024 11.0944 18.7141 11.7446C18.9258 12.3947 18.9117 13.092 18.6739 13.734C18.436 14.376 17.9869 14.929 17.3925 15.3117C18.4242 15.6698 19.3191 16.3118 19.9619 17.1552C20.6047 17.9986 20.9661 19.0047 20.9994 20.044C21.0025 20.1017 20.9934 20.1594 20.9727 20.2137C20.9519 20.268 20.9199 20.3179 20.8785 20.3604C20.8371 20.4028 20.7871 20.437 20.7316 20.461C20.676 20.4849 20.616 20.4981 20.5549 20.4998C20.4939 20.5015 20.4332 20.4917 20.3762 20.4708C20.3193 20.45 20.2673 20.4186 20.2233 20.3785C20.1794 20.3385 20.1443 20.2905 20.1202 20.2374C20.0961 20.1843 20.0835 20.1272 20.083 20.0695C20.0466 18.9423 19.5478 17.8729 18.6923 17.0878C17.8368 16.3027 16.6919 15.8636 15.5001 15.8636C14.3083 15.8636 13.1634 16.3027 12.3079 17.0878C11.4524 17.8729 10.9536 18.9423 10.9172 20.0695C10.9136 20.1845 10.8618 20.2935 10.7732 20.3724C10.6846 20.4513 10.5666 20.4937 10.445 20.4903C10.3234 20.4868 10.2082 20.4378 10.1248 20.354C10.0414 20.2702 9.99656 20.1585 10.0002 20.0434C10.0337 19.0042 10.3951 17.9982 11.0379 17.1549C11.6807 16.3117 12.5755 15.6697 13.6071 15.3117C13.0127 14.929 12.5636 14.376 12.3257 13.734C12.0879 13.092 12.0738 12.3947 12.2855 11.7446C12.4973 11.0944 12.9237 10.5256 13.5022 10.1216C14.0807 9.71767 14.7808 9.49979 15.4998 9.5ZM13.0545 12.6815C13.0545 13.2951 13.3121 13.8837 13.7707 14.3176C14.2293 14.7515 14.8513 14.9953 15.4998 14.9953C16.1484 14.9953 16.7703 14.7515 17.2289 14.3176C17.6875 13.8837 17.9452 13.2951 17.9452 12.6815C17.9452 12.0678 17.6875 11.4793 17.2289 11.0454C16.7703 10.6115 16.1484 10.3677 15.4998 10.3677C14.8513 10.3677 14.2293 10.6115 13.7707 11.0454C13.3121 11.4793 13.0545 12.0678 13.0545 12.6815Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4998 9.5C16.2188 9.49979 16.9189 9.71767 17.4974 10.1216C18.0759 10.5256 18.5024 11.0944 18.7141 11.7446C18.9258 12.3947 18.9117 13.092 18.6739 13.734C18.436 14.376 17.9869 14.929 17.3925 15.3117C18.4242 15.6698 19.3191 16.3118 19.9619 17.1552C20.6047 17.9986 20.9661 19.0047 20.9994 20.044C21.0025 20.1017 20.9934 20.1594 20.9727 20.2137C20.9519 20.268 20.9199 20.3179 20.8785 20.3604C20.8371 20.4028 20.7871 20.437 20.7316 20.461C20.676 20.4849 20.616 20.4981 20.5549 20.4998C20.4939 20.5015 20.4332 20.4917 20.3762 20.4708C20.3193 20.45 20.2673 20.4186 20.2233 20.3785C20.1794 20.3385 20.1443 20.2905 20.1202 20.2374C20.0961 20.1843 20.0835 20.1272 20.083 20.0695C20.0466 18.9423 19.5478 17.8729 18.6923 17.0878C17.8368 16.3027 16.6919 15.8636 15.5001 15.8636C14.3083 15.8636 13.1634 16.3027 12.3079 17.0878C11.4524 17.8729 10.9536 18.9423 10.9172 20.0695C10.9136 20.1845 10.8618 20.2935 10.7732 20.3724C10.6846 20.4513 10.5666 20.4937 10.445 20.4903C10.3234 20.4868 10.2082 20.4378 10.1248 20.354C10.0414 20.2702 9.99656 20.1585 10.0002 20.0434C10.0337 19.0042 10.3951 17.9982 11.0379 17.1549C11.6807 16.3117 12.5755 15.6697 13.6071 15.3117C13.0127 14.929 12.5636 14.376 12.3257 13.734C12.0879 13.092 12.0738 12.3947 12.2855 11.7446C12.4973 11.0944 12.9237 10.5256 13.5022 10.1216C14.0807 9.71767 14.7808 9.49979 15.4998 9.5ZM13.0545 12.6815C13.0545 13.2951 13.3121 13.8837 13.7707 14.3176C14.2293 14.7515 14.8513 14.9953 15.4998 14.9953C16.1484 14.9953 16.7703 14.7515 17.2289 14.3176C17.6875 13.8837 17.9452 13.2951 17.9452 12.6815C17.9452 12.0678 17.6875 11.4793 17.2289 11.0454C16.7703 10.6115 16.1484 10.3677 15.4998 10.3677C14.8513 10.3677 14.2293 10.6115 13.7707 11.0454C13.3121 11.4793 13.0545 12.0678 13.0545 12.6815Z",
    stroke: "currentColor",
    strokeWidth: 0.2,
    mask: "url(#path-4-outside-1_0_1)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_0_1",
    x: -55,
    y: -816,
    width: 453,
    height: 912,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_0_1",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_0_1",
    x: -35,
    y: -30,
    width: 413,
    height: 97,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_0_1",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 393,
    height: 852,
    fill: "var(--background)",
    transform: "translate(-25 -790)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPanelProfile);
export default __webpack_public_path__ + "static/media/panelProfile.03d2eb1cd6eebb263083dbe0b69bc68a.svg";
export { ForwardRef as ReactComponent };